<template>
  <div class="school-semester" style="padding:20px;">
    <!-- 搜索 -->
    <div style="margin-bottom:20px;">
      <el-input
        v-model="schoolName"
        placeholder="学校名称搜索"
        style="width:280px; margin-right:10px;"
        clearable
      />
      <el-button type="primary" @click="getList">搜索</el-button>
    </div>

    <!-- 表格 -->
    <el-table :data="tableData" border stripe>
      <el-table-column label="序号" prop="schoolId" width="100" align="center">
	  <template slot-scope="scope">
	       {{(pageNum-1)*pageSize+scope.$index+1}}
	    </template>
	  </el-table-column>
      <el-table-column label="学校名称" prop="schoolName" min-width="180" align="center"/>

      <el-table-column label="当前学期" min-width="160" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.currentYear">
            {{ scope.row.currentYear }}学年
            <el-tag type="success">{{ scope.row.currentTerm==1 ? '第一学期' : '第二学期' }}</el-tag>
          </span>
          <span v-else style="color:#999">未设置</span>
        </template>
      </el-table-column>

      <el-table-column label="开始时间" width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.startTime ? formatTime(scope.row.startTime) : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="结束时间" width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.endTime ? formatTime(scope.row.endTime) : '-' }}
        </template>
      </el-table-column>

      <el-table-column label="首个学期" width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.firstYear ? `${scope.row.firstYear}学年--${scope.row.firstTerm==1 ? '第一学期' : '第二学期'}` : '-' }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="openDetail(scope.row)">查看明细</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @current-change="getLists"
      :current-page="pageNum"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total"
      style="margin-top:20px; text-align:right;"
    />

    <!-- 明细弹窗 -->
    <el-dialog
      title="学校学期明细"
      :visible.sync="detailVisible"
      width="70%"
      append-to-body
    >
      <div style="margin-bottom:12px;">
        学校：<span style="color:#409EFF;font-weight:bold">{{ currentSchoolName }}</span>
      </div>

      <el-table :data="semesterList" border>
        <el-table-column label="年份" prop="year" width="120"/>
        <el-table-column label="学期" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.term==1 ? 'primary' : 'warning'">
              {{ scope.row.term==1 ? '上' : '下' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="开始时间" prop="startTime" width="180">
          <template slot-scope="scope">{{ formatTime(scope.row.startTime) }}</template>
        </el-table-column>
        <el-table-column label="结束时间" prop="endTime" width="180">
          <template slot-scope="scope">{{ formatTime(scope.row.endTime) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status==1 ? 'success' : scope.row.status==2 ? 'danger' : 'info'">
              {{ scope.row.status==1 ? '启用' : scope.row.status==2 ? '结束' : '未开始' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      schoolName: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      // 明细
      detailVisible: false,
      currentSchoolId: 0,
      currentSchoolName: '',
      semesterList: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取学校分页列表
    getList() {
      this.API.get(this.API.admin.getSchoolListWithSemester, {
          schoolName: this.schoolName,
          pageNum: this.pageNum,
          pageSize: this.pageSize
      }).then(res => {
        // if (res.code === 0) {
          this.tableData = res.data.data.records
          this.total = res.data.data.total
        // }
      })
    },
	getLists(val){
		
		this.pageNum=val
		this.getList()
	},
    // 打开学期明细
    openDetail(row) {
      this.currentSchoolId = row.schoolId
      this.currentSchoolName = row.schoolName
      this.detailVisible = true
      this.getSemesterList()
    },

    // 学期明细列表
   openDetail(row) {
     this.$router.push({
       path: "/school/semester/detail", // 你自己的路由地址
       query: {
         schoolId: row.schoolId,
         schoolName: row.schoolName
       }
     });
   },

    // 时间格式化
    formatTime(timestamp) {
      if (!timestamp) return '-'
      let date = new Date(timestamp)
      let y = date.getFullYear()
      let m = (date.getMonth() + 1 + '').padStart(2, '0')
      let d = (date.getDate() + '').padStart(2, '0')
      let hh = (date.getHours() + '').padStart(2, '0')
      let mm = (date.getMinutes() + '').padStart(2, '0')
      return `${y}-${m}-${d}`//${hh}:${mm}
    }
  }
}
</script>